// src/components/ResumeBuilder/forms/LanguageForm.jsx
import React, { useContext } from "react";
import {
  Box,
  Card,
  Grid,
  TextField,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import GradientButton from "../Button";
import { ResumeContext } from "../../ResumeContext";
import { saveResumeData } from "../../api/resumeapi";
import BasicInfoSkeleton from "./skeletonLoader";
import { LanguageSchema } from "./resumevalidation";

export default function LanguageForm({ onNext }) {
  const { data, setData, loading } = useContext(ResumeContext);

  //  Skeleton while loading
  if (loading || !data) {
    return <BasicInfoSkeleton />;
  }

  return (
    <Card sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography fontSize={13} color="#6E6D81" mb={2}>
        52% of India's youth is bilingual, how are you contributing to this?
      </Typography>

      <Formik
        enableReinitialize
        initialValues={{
          languages:
            Array.isArray(data?.languageArr) && data.languageArr.length > 0
              ? data.languageArr
              : [{ language: "", level: "" }],
        }}
        validationSchema={LanguageSchema}
        onSubmit={async (values) => {
          const payload = {
            ...data,
            languageArr: values.languages,
          };

          try {
            // SAVE TO DB
            console.log("Saving Languages:", values.languages,payload);
            await saveResumeData(payload);

            // UPDATE CONTEXT (merge)
            setData((prev) => ({
              ...prev,
              languageArr: values.languages,
            }));
          } catch (err) {
            console.error("LANGUAGE SAVE ERROR:", err);
          }
        }}
      >
        {({ values, handleChange }) => (
          <Form>
            <FieldArray name="languages">
              {({ push, remove }) => (
                <Box>
                  {values.languages.map((_, idx) => (
                    <Grid
                      container
                      spacing={2}
                      key={idx}
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                          fullWidth
                          label="Language"
                          name={`languages[${idx}].language`}
                          size="small"
                          value={values.languages[idx].language}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 5 }}>
                        <TextField
                          fullWidth
                          label="Proficiency (Beginner / Intermediate / Advanced)"
                          name={`languages[${idx}].level`}
                          size="small"
                          value={values.languages[idx].level}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 1 }} textAlign="right">
                        <IconButton
                          color="error"
                          disabled={values.languages.length === 1}
                          onClick={() => remove(idx)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <Box mt={1}>
                    <Button
                      startIcon={<AddIcon />}
                      onClick={() => push({})}
                    >
                      Add language
                    </Button>
                  </Box>
                </Box>
              )}
            </FieldArray>

            {/* BUTTONS */}
            <Box mt={3} display="flex" justifyContent="center" gap={4}>
              {/* NEXT: navigation only */}
              <GradientButton
                type="button"
                onClick={onNext}
              >
                Next
              </GradientButton>

              {/* SAVE: submit */}
              <GradientButton type="submit">
                Save
              </GradientButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
